import React from 'react';
import './css/App.css';
import { Route, Routes } from 'react-router-dom';
import MonthlyStatement from './pages/MonthlyStatement.jsx';
import AccountantsList from './pages/AccountantsList.jsx';
import ClientsList from './pages/ClientsList.jsx';
import ClientSurvey from './pages/ClientSurvey.jsx';
import SignIn from './pages/SignIn';
import GenerateInvoices from './pages/GenerateInvoices';
import AdditionalCosts from './pages/AdditionalCosts.jsx';
import ApproveStatements from './pages/ApproveStatements';
import StartAccounting from './pages/StartAccounting';
import Overview from './pages/Overview';
import Missing from './security/Missing';
import Unauthorized from './security/Unauthorized';
import SessionExpired from './security/SessionExpired';
import MyRequireAuth from './security/MyRequireAuth';
import Imports from './components/Imports';
import Settings from './pages/Settings.jsx';
import DebtCollection from './pages/DebtCollection.jsx';
import LayoutWithSidebar from './components/Sidebar.jsx';
import FinancialStatements from './pages/FinancialStatements.jsx';
import SalaryBlocks from './pages/SalaryBlocks.jsx';
import SessionTimeoutNotification from './security/SessionTimeoutNotification';

const App = () => {
  return (
    <div>
      {/* Globalny monitor sesji */}
      <SessionTimeoutNotification />

      <Routes>
        <Route path="/SignIn" element={<SignIn />} />
        <Route path="/" element={<SignIn />} />
        <Route path="/Unauthorized" element={<Unauthorized />} />
        <Route path="/SessionExpired" element={<SessionExpired />} />

        <Route element={<LayoutWithSidebar />}>
          <Route path="/ClientsList" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["SUPERVISOR", "SUPERVISOR_ACCOUNTANT", "ADMIN", "TRADER", "ACCOUNT_MANAGER", "MANAGER", "ADMIN_SUPERVISOR", "ACCOUNTANT", "CHIEF_ACCOUNTANT", "EXTERNAL_IT"]}>
              <ClientsList />
            </MyRequireAuth>
          } />
          <Route path="/MonthlyStatement" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["ACCOUNTANT", "SUPERVISOR", "SUPERVISOR_ACCOUNTANT", "ADMIN", "MANAGER", "ADMIN_SUPERVISOR", "CHIEF_ACCOUNTANT"]}>
              <MonthlyStatement />
            </MyRequireAuth>
          } />
          <Route path="/GenerateInvoices" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["ADMIN", "MANAGER", "ADMIN_SUPERVISOR", "ACCOUNTANT", "CHIEF_ACCOUNTANT", "SUPERVISOR_ACCOUNTANT"]}>
              <GenerateInvoices />
            </MyRequireAuth>
          } />
          <Route path="/AdditionalCosts" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["ADMIN", "ADMIN_SUPERVISOR", "MANAGER", "ACCOUNTANT", "CHIEF_ACCOUNTANT", "SUPERVISOR_ACCOUNTANT"]}>
              <AdditionalCosts />
            </MyRequireAuth>
          } />
          <Route path="/FinancialStatements" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["SUPERVISOR", "SUPERVISOR_ACCOUNTANT", "ADMIN", "ACCOUNT_MANAGER", "MANAGER", "ADMIN_SUPERVISOR", "CHIEF_ACCOUNTANT", "ACCOUNTANT"]}>
              <FinancialStatements />
            </MyRequireAuth>
          } />
          <Route path="/AccountantsList" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["SUPERVISOR", "SUPERVISOR_ACCOUNTANT", "ADMIN", "TRADER", "ACCOUNT_MANAGER", "MANAGER", "ADMIN_SUPERVISOR", "CHIEF_ACCOUNTANT", "EXTERNAL_IT"]}>
              <AccountantsList />
            </MyRequireAuth>
          } />
          <Route path="/ApproveStatements" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["SUPERVISOR", "SUPERVISOR_ACCOUNTANT", "ADMIN", "ADMIN_SUPERVISOR", "MANAGER", "CHIEF_ACCOUNTANT"]}>
              <ApproveStatements />
            </MyRequireAuth>
          } />
          <Route path="/StartAccounting" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["ADMIN", "ADMIN_SUPERVISOR", "MANAGER", "SUPERVISOR", "SUPERVISOR_ACCOUNTANT", "ACCOUNT_MANAGER"]}>
              <StartAccounting />
            </MyRequireAuth>
          } />
          <Route path="/Overview" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["ADMIN", "ADMIN_SUPERVISOR"]}>
              <Overview />
            </MyRequireAuth>
          } />
          <Route path="/DebtCollection" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["ADMIN", "ADMIN_SUPERVISOR", "MANAGER", "ACCOUNT_MANAGER", "TRADER"]}>
              <DebtCollection />
            </MyRequireAuth>
          } />
          <Route path="/Settings" element={
            <MyRequireAuth loginPath="/SignIn">
              <Settings />
            </MyRequireAuth>
          } />
          <Route path="/ClientSurvey" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["ADMIN", "ADMIN_SUPERVISOR", "MANAGER"]}>
              <ClientSurvey />
            </MyRequireAuth>
          } />
          <Route path="/Imports" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["ADMIN", "ADMIN_SUPERVISOR", "MANAGER"]}>
              <Imports />
            </MyRequireAuth>
          } />
          <Route path="/SalaryBlocks" element={
            <MyRequireAuth loginPath="/SignIn" allowedRoles={["SUPERVISOR", "SUPERVISOR_ACCOUNTANT", "ADMIN", "ADMIN_SUPERVISOR", "MANAGER", "ACCOUNTANT", "CHIEF_ACCOUNTANT"]}>
              <SalaryBlocks />
            </MyRequireAuth>
          } />
        </Route>

        <Route path="*" element={<Missing />} />
      </Routes>
    </div>
  );
};

export default App;